/* eslint-disable jsx-a11y/media-has-caption */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { LoadingSpinner } from 'yankees-react-utils';
import { useBlobDownloadQuery } from '../data';

const VideoProtectedDisplay = ({ videourl, alt, style, mime, ...rest }) => {
    const [loaded, setLoaded] = useState(false);
    const { src } = useBlobDownloadQuery(videourl);
    return (
        <>
            {!loaded && <LoadingSpinner />}
            <video
                src={src}
                alt={alt}
                mime={mime}
                style={loaded ? style : { display: 'none' }}
                onLoadedData={() => setLoaded(true)}
                {...rest}
            />
        </>
    );
};

VideoProtectedDisplay.defaultProps = {
    alt: '',
    style: null,
    mime: 'video/mp4',
};

VideoProtectedDisplay.propTypes = {
    videourl: PropTypes.string.isRequired,
    alt: PropTypes.string,
    style: PropTypes.shape({}),
    mime: PropTypes.string,
};

export default VideoProtectedDisplay;
